import { render, staticRenderFns } from "./shoppingCategory.vue?vue&type=template&id=36c562cc&scoped=true&"
import script from "./shoppingCategory.vue?vue&type=script&lang=js&"
export * from "./shoppingCategory.vue?vue&type=script&lang=js&"
import style0 from "./shoppingCategory.vue?vue&type=style&index=0&lang=css&"
import style1 from "./shoppingCategory.vue?vue&type=style&index=1&id=36c562cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c562cc",
  null
  
)

export default component.exports